import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import ChangePassword from './ChangePassword';

export const AccountRoutes = (
  <Route path="account" element={<Outlet />}>
    <Route
      path="chpass"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health', 'Manufacturer Users']}>
          <ChangePassword />
        </PrivateRoute>
      )}
    />

    <Route
      path="setpass"
      element={<ChangePassword setPassword />}
    />
  </Route>
);
